import * as StM  from '../../../store';

export interface ISeekingPlayerBoardPageStoreState {
    sessions: Array<StM.ISessionStoreState>;
}

export class SeekingPlayerBoardPageStoreState implements ISeekingPlayerBoardPageStoreState {
    sessions: Array<StM.ISessionStoreState>;
    constructor() {
        this.sessions = new Array();
    }
}
